/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespEditorialModule_componentModule = {
    readonly items: ReadonlyArray<{
        readonly cmsId: number | null;
        readonly linkData: {
            readonly path: string | null;
        };
        readonly " $fragmentRefs": FragmentRefs<"HpRespEditorialModuleItem_item">;
    } | null> | null;
    readonly " $refType": "HpRespEditorialModule_componentModule";
};
export type HpRespEditorialModule_componentModule$data = HpRespEditorialModule_componentModule;
export type HpRespEditorialModule_componentModule$key = {
    readonly " $data"?: HpRespEditorialModule_componentModule$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespEditorialModule_componentModule">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpRespEditorialModule_componentModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EditorialItem",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cmsId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LinkData",
          "kind": "LinkedField",
          "name": "linkData",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "path",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpRespEditorialModuleItem_item"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "EditorialModule",
  "abstractKey": null
};
(node as any).hash = 'ff8d84ae71621c68c279c815d0cb9d9c';
export default node;
